const WELCOME_PREFIX = 'peppar_vc_welcome_';
const NUDGE_PREFIX = 'peppar_vc_nudge_';
const STATUS_PREFIX = 'peppar_vc_status_';
const ITEM_STATUS_PREFIX = 'peppar_vc_item_';
const WAIT_PREFIX = 'peppar_vc_wait_';
const VOICE_TIP_KEY = 'peppar_vc_voice_tip_dismissed';
const POPOVER_DISMISS_PREFIX = 'peppar_vc_popover_dismiss_';
const AUTO_OPEN_UPDATES_KEY = 'peppar_vc_auto_open_updates';
export const AI_CAPTAIN_PAGE_EVENT_KEY = 'pepparAiCaptainLastPageKey';

function read(key: string): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value = '1'): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // ignore quota / private mode
  }
}

function readLocal(key: string): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeLocal(key: string, value: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore quota / private mode
  }
}

export function hasRestaurantWelcome(appName: string): boolean {
  return read(`${WELCOME_PREFIX}${appName}`) === '1';
}

export function markRestaurantWelcomed(appName: string): void {
  write(`${WELCOME_PREFIX}${appName}`);
}

export function hasPageNudge(appName: string, nudgeKey: string): boolean {
  return read(`${NUDGE_PREFIX}${appName}_${nudgeKey}`) === '1';
}

export function markPageNudge(appName: string, nudgeKey: string): void {
  write(`${NUDGE_PREFIX}${appName}_${nudgeKey}`);
}

export function hasAnnouncedOrderStatus(orderId: number, status: string): boolean {
  return read(`${STATUS_PREFIX}${orderId}_${status}`) === '1';
}

export function markAnnouncedOrderStatus(orderId: number, status: string): void {
  write(`${STATUS_PREFIX}${orderId}_${status}`);
}

export function hasAnnouncedItemStatus(orderItemId: number | string, status: string): boolean {
  return read(`${ITEM_STATUS_PREFIX}${orderItemId}_${status}`) === '1';
}

export function markAnnouncedItemStatus(orderItemId: number | string, status: string): void {
  write(`${ITEM_STATUS_PREFIX}${orderItemId}_${status}`);
}

export function hasAnnouncedWaitTime(orderId: number, minutes: number): boolean {
  return read(`${WAIT_PREFIX}${orderId}_${minutes}`) === '1';
}

export function markAnnouncedWaitTime(orderId: number, minutes: number): void {
  write(`${WAIT_PREFIX}${orderId}_${minutes}`);
}

export function isVoiceTipDismissed(): boolean {
  return read(VOICE_TIP_KEY) === '1';
}

export function markVoiceTipDismissed(): void {
  write(VOICE_TIP_KEY);
}

/** Align with useAiCaptainSession so local nudges do not re-trigger AI page events. */
export function markAiCaptainPageVisited(pageKey: string): void {
  write(AI_CAPTAIN_PAGE_EVENT_KEY, pageKey);
}

export function hasAiCaptainPageVisited(pageKey: string): boolean {
  return read(AI_CAPTAIN_PAGE_EVENT_KEY) === pageKey;
}

/** Popover was dismissed for this message — stay closed until a newer notification arrives. */
export function isPopoverDismissedForMessage(appName: string, messageId: string): boolean {
  if (!appName || !messageId) return false;
  return read(`${POPOVER_DISMISS_PREFIX}${appName}`) === messageId;
}

export function markPopoverDismissed(appName: string, messageId: string): void {
  if (!appName || !messageId) return;
  write(`${POPOVER_DISMISS_PREFIX}${appName}`, messageId);
}

/** When false, Peppy does not auto-open the popover for order updates. */
export function isAutoOpenUpdatesEnabled(): boolean {
  return readLocal(AUTO_OPEN_UPDATES_KEY) !== '0';
}

export function setAutoOpenUpdatesEnabled(enabled: boolean): void {
  writeLocal(AUTO_OPEN_UPDATES_KEY, enabled ? '1' : '0');
}
